import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

// Real backend: PATCH /:id/status — body: { status, reason }
// Used only for the lifecycle transitions that don't have their own dedicated
// endpoint (DRAFT -> REGISTERED -> AVAILABLE). Allocate/Return/Service/Dispose
// still go through their own specific endpoints, not this generic one.
export const updateAssetStatus = createAsyncThunk("updateAssetStatus", async ({ id, status, reason }) => {
	const response = await axiosHttp.patch(`assets/${id}/status`, { status, reason });
	message.success(`Asset status updated to ${status}`);
	return response.data?.data ?? response.data;
});

const AssetStatusSlice = createSlice({
	name: "assetStatusSlice",
	initialState: { isLoading: false, error: null },
	extraReducers: (builder) => {
		builder.addCase(updateAssetStatus.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(updateAssetStatus.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(updateAssetStatus.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default AssetStatusSlice.reducer;
